/**
 * Canonical file-type identifiers exchanged with the backend
 * `/otk-service/get-upload-url` endpoint.
 *
 * Values mirror the field names stored inside
 * `journey.capturedData.images.*` on the backend so the frontend can
 * pass the same string for both the storage key and the journey-update
 * payload.
 *
 * Keep this list in sync with `one-journey-backend/constants/s3Constants.js`.
 */
export const FileType = {
    FRONT_DOC: "frontDoc",
    BACK_DOC: "backDoc",
    FRONT_DOC_2: "frontDoc2",
    BACK_DOC_2: "backDoc2",
    FRONT_DOC_3: "frontDoc3",
    BACK_DOC_3: "backDoc3",
    SELFIE: "selfie"
};

/**
 * Map a document iteration (0-indexed `currentDocumentStep`) to its
 * front / back FileType.
 *
 *   step 0 → { front: FRONT_DOC,   back: BACK_DOC }
 *   step 1 → { front: FRONT_DOC_2, back: BACK_DOC_2 }
 *   step 2 → { front: FRONT_DOC_3, back: BACK_DOC_3 }
 */
export const getDocumentFileTypes = (currentDocumentStep) => {
    const step = Number(currentDocumentStep) || 0;
    if (step === 0) {
        return { front: FileType.FRONT_DOC, back: FileType.BACK_DOC };
    }
    if (step === 1) {
        return { front: FileType.FRONT_DOC_2, back: FileType.BACK_DOC_2 };
    }
    return { front: FileType.FRONT_DOC_3, back: FileType.BACK_DOC_3 };
};

/**
 * Mirror of `ALLOWED_UPLOAD_MIME_TYPES` in
 * `one-journey-backend/constants/s3Constants.js`. The capture pickers
 * (`MobileDocumentCapture.jsx` etc.) can accept these mime types, and
 * the backend presigned-POST policy will sign requests for them.
 */
export const ALLOWED_UPLOAD_MIME_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/heic",
    "image/heif",
    "application/pdf"
];
